import { Inject, Component, Optional, Input } from "@angular/core";
import { BaseActionBoxComponent } from "../..";
import { ConfiguratorStore } from "../../../configurator/providers";
import { ProductDataStore } from "../../providers/productData";
import { CodePanel, Form, RequestViews } from "../../models";


@Component({
  selector: 'form-action-box',
  templateUrl: './formActionBoxComponent.html'
})
export class FormActionBoxComponent extends BaseActionBoxComponent {

  @Input()
  form: Form;

  actionBoxTitle: string;

  RequestViews = RequestViews;

  constructor(
    @Optional() @Inject(ConfiguratorStore) configuratorStore: ConfiguratorStore,
    @Inject(ProductDataStore) private productStore: ProductDataStore) {
    super(configuratorStore);
  }

  public setup(): void {

    let panel: Form = this.productStore.getEntity<Form>(this.form.longId);
    this.actionBoxTitle = panel.title ? panel.title : this.strings.Form;
    
  }

  // TODO: Need to remove this
  public shouldBeVisible(): boolean {
    return true;
  }

}